
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 4h24v24H4V4zm2 2v20h2v-1h2v1h12v-1h2v1h2V6h-2v1h-2V6H10v1H8V6H6zm2 3h2v2H8V9zm14 0h2v2h-2V9zM8 13h2v2H8v-2zm14 0h2v2h-2v-2zM8 17h2v2H8v-2zm14 0h2v2h-2v-2zM8 21h2v2H8v-2zm14 0h2v2h-2v-2z"}})])
          )
        }
      }
    